import BaseRepository from './base.repository';

class ResourcesRepository extends BaseRepository {
  constructor() {
    super('/more');
  }

  getContentCategories() {
    return this.client.get('/content-categories');
  }

  getTreatmentContents(params) {
    return this.client.get('/micro-educations', params);
  }

  getTreatmentContent(mainUnique) {
    return this.client.get(`/micro-educations/${mainUnique}`);
  }

  recordContentRead(mainUnique, context) {
    return this.client.post(`/micro-educations/${mainUnique}/read`, {}, { params: context });
  }

  getFaqs(params) {
    return this.client.get('/faqs', params);
  }

  getSocialLinks(params) {
    return this.client.get('/social', params);
  }
}

export default new ResourcesRepository();
